import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import usePortal from 'hooks/usePortal'
import { ReactComponent as Delete } from '../../shared/icons/delete.svg'
import styles from '../Modal.module.scss'

import { ProgressBar } from 'components/Loading'
import { StyledLabel, StyledWindow, StyledOverlay, StyledContent, ProgressContainer } from '../styled/common'

const Modal = ({ type, children, label, unmount, width = 690, showModal = true, height, className, fullScreen, contentClassName, labelStyles = {}, loadingProgress, style }) => {
	const portal = usePortal('root', classNames(styles.root, className))
	useEffect(() => {
		const mainContainer = document.getElementById('container')
		// const bodyDefaultOverflow = document.body.style.overflow
		document.body.style.overflow = 'hidden'
		if(fullScreen && mainContainer) {
			mainContainer.style.display = 'none'
		}
		return () => {
			// If using wait modal and after it another modal bodyDefaultOverflow can be 'hidden'
			// document.body.style.overflow = bodyDefaultOverflow
			document.body.style.removeProperty('overflow')
			if(fullScreen && mainContainer) {
				mainContainer.style.display = 'block'
			}
		}
	}, [fullScreen])

	const handleOverlayClick = () => {//it will be called only if user clicked outside of Modal
		unmount()
	}
	const additionalStyles = {
		width: fullScreen ? '100%' : `${width}px`,
		height: fullScreen ? '100%' : `${height ? height + 'px' : ''}`,
		...style
	}

	const modalComponent = (
		<>
			{!fullScreen && <StyledOverlay onClick={handleOverlayClick}/>}
			<StyledWindow isFullScreen={fullScreen} additionalStyles={additionalStyles}>
				<StyledLabel type={type} {...labelStyles && { style: labelStyles }}>
					{label}
					<Delete onClick={unmount}/>
				</StyledLabel>
				<StyledContent additionalStyles={additionalStyles} className={contentClassName}>
					{(typeof loadingProgress === 'number') &&
						<ProgressContainer>
							<ProgressBar progress={loadingProgress} />
						</ProgressContainer>
					}
					{children}
				</StyledContent>
			</StyledWindow>
		</>
	)
	return showModal && ReactDOM.createPortal(modalComponent, portal)
}

Modal.propTypes = {
	unmount: PropTypes.func.isRequired,
	type: PropTypes.oneOf(['alert'])
}

export default Modal
